import { useEffect } from 'react';
import { useGameStore } from '@/state/gameStore';
import { loadNpcStations, filterAvailableNpcs } from '@/data/npcStations';
import { getRadiusKm } from '@/data/leveling';

/**
 * Phase 7.2.4 — Loads NPC stations (OSM amenities) for the current city
 * radius and filters out those too close to player-owned stations.
 */
export function useNpcStationsLoader() {
  const homeCity = useGameStore((s) => s.homeCity);
  const level = useGameStore((s) => s.level);
  const ownedStations = useGameStore((s) => s.stations);
  const setNpcStations = useGameStore((s) => s.setNpcStations);

  useEffect(() => {
    if (!homeCity) return;
    const ctrl = new AbortController();
    const radiusKm = getRadiusKm(level);
    void loadNpcStations(homeCity.center, radiusKm, homeCity.addressType, ctrl.signal, {
      cityName: homeCity.displayName,
      cityPopulation: homeCity.population,
    }).then((npcs) => {
      if (ctrl.signal.aborted) return;
      const filtered = filterAvailableNpcs(
        npcs,
        ownedStations.map((s) => s.position),
        0.5,
      );
      setNpcStations(filtered);
    });
    return () => ctrl.abort();
  }, [homeCity, level, ownedStations, setNpcStations]);
}
